import * as React from 'react'
import {Hub} from '@aws-amplify/core'
import {useLocation, useNavigate} from 'react-router'
import {observer} from 'mobx-react-lite'
import {Authentication} from './authentication'
import {getAuthenticationInstance} from './authenticationInstance'
import {definedContextValueHookFactory} from '@oc/hooks'

const AuthenticationContext = React.createContext<Authentication | null>(null)

export const useAuthInfo = definedContextValueHookFactory(AuthenticationContext, 'AuthenticationContext')

export function AuthenticationContextProvider(props: React.PropsWithChildren) {
    const authenticationInstance = getAuthenticationInstance()

    return (
        <AuthenticationContext.Provider value={authenticationInstance}>
            <CognitoProvider>{props.children}</CognitoProvider>
        </AuthenticationContext.Provider>
    )
}

function _CognitoProvider(props: React.PropsWithChildren) {
    const navigate = useNavigate()
    const location = useLocation()
    const {isLoggedIn, signIn} = useAuthInfo()

    React.useEffect(() => {
        return Hub.listen('auth', args => {
            switch (args.payload.event) {
                case 'customOAuthState':
                    navigate(args.payload.data)
                    break
            }
        })
    }, [navigate])

    React.useEffect(() => {
        if (!isLoggedIn) {
            // fire and forget
            signIn(`${location.pathname}${location.search}${location.hash}`)
        }
    }, [isLoggedIn, signIn, location])

    if (!isLoggedIn) {
        return null
    }

    return props.children
}
const CognitoProvider = observer(_CognitoProvider)
